<script lang="ts">
    import {onMount} from "svelte";
    import HeadingTitleView from "../../../../component/common/Typography/HeadingTitleView.svelte";
    import TabView from "../../../../component/common/Tab/TabView.svelte";
    import TabContentView from "../../../../component/common/Tab/TabContentView.svelte";
    import SpaceCompanyDepartmentView from "./SpaceCompanyDepartment/SpaceCompanyDepartmentView.svelte";
    import SpaceUserView from "./SpaceUser/SpaceUserView.svelte";
    import SpaceLoadView from "../../../../component/Space/SpaceLoadView.svelte";

    export let params;

    let space = null;

    onMount(() => {
    });

    function onLoadSpace(event) {
        space = event.detail.space;
    }

</script>

<div class="space-authority-page standard-page">

    <SpaceLoadView spaceUniqueId={params.space_unique_id} on:load={onLoadSpace} isShowNotFoundMessage={true}>
        <HeadingTitleView title="スペース権限">

        </HeadingTitleView>

        <div>
            <TabView let:activeTabName>
                <TabContentView tabName="会社/部署" activeTabName={activeTabName}>
                    <div class="space-company-department-area">
                        <SpaceCompanyDepartmentView space={space} on:update/>

                    </div>

                </TabContentView>
                <TabContentView tabName="個別ユーザー" activeTabName={activeTabName}>
                    <div class="space-user-area">
                        <SpaceUserView space={space} on:update/>

                    </div>

                </TabContentView>
            </TabView>
        </div>


    </SpaceLoadView>


</div>
<style lang="scss">
    .space-authority-page {

    }
</style>